export const logSdkError = (errorMessage: string) => {
	console.error(`Wix code SDK error: ${errorMessage}`)
}

export const logSdkWarning = (warningMessage: string) => {
	console.warn(`Wix code SDK warning: ${warningMessage}`)
}
